import _forEach from 'lodash/forEach';

/**
 * @private
 * @class
 *
 * @description
 * Переключение типов цен для ProductInstance
 */

var InstancePriceKinds = function(price_kinds) {
  var self = this;

  self.price_kinds = price_kinds;

  return self;
};

InstancePriceKinds.prototype.get = function(options) {
  var self = this;
  var _prices = self._getPriceKinds(options.variantId);
  var price = 0;

  _forEach(_prices, function(price_type) {
    if (options.quantity < price_type.min_quantity) {
      return false;
    }

    price = price_type.price;
  });

  return price;
};

InstancePriceKinds.prototype._getPriceKinds = function(variantId) {
  var self = this;

  return self.price_kinds[variantId];
};

export default InstancePriceKinds;
